
















import { EnumType } from 'expangine-runtime';
import { EnumSliderOptions } from './EnumSliderTypes';
import { TypeSettings } from '../TypeVisuals';
import { EnumSubs } from './EnumTypes';
import { ListOptions } from '../../../common';
import TypeInputBase from '../TypeInputBase';


export default TypeInputBase<EnumType, EnumSliderOptions, any, EnumSubs>().extend({
  name: 'EnumSlider',
  computed: {
    sliderValue: {
      get(): number {
        return this.values.indexOf(this.computedValue);
      },
      set(index: number) {
        this.computedValue = this.values[index];
      },
    },
    entries(): Array<[any, any]> {
      return Array.from(this.type.options.constants.entries());
    },
    keys(): any[] {
      return this.entries.map(([k, v]) => k);
    },
    values(): any[] {
      return this.entries.map(([k, v]) => v);
    },
    max(): number {
      return this.keys.length - 1;
    },
    hasHint(): boolean {
      return !this.hideHint;
    },
    hideHint(): boolean {
      return !this.settings.options.hint;
    },
  },
});
